import localization from '@/constant/localization';
import Container from '@/components/@base/container';
import { SIZE_ENUM } from '@/components/@base/@types';
import { Text } from '@/components/@base/typography';
import FontIcon from '@/components/@base/font-icon';
import Button from '@/components/@base/button';

const OffLine = () => {
  return (
    <Container
      center
      className='h-[100vh] w-full flex-col gap-3 bg-grayLight-0 dark:bg-grayDark-950 px-6 i5:px-8 fixed top-0 bottom-0 left-0 right-0 z-[100000]'
    >
      <FontIcon icon="icon-wifi" className='text-[40px] text-red bg-red-50 rounded-full h-[56px] w-[56px] flex items-center justify-center'/>
      <Text size={SIZE_ENUM.LG} className='mt-6 text-black dark:text-white leading-7' semiBold>{localization.yourLostYourConnection}</Text>
      <Text size={SIZE_ENUM.MD} className='text-grayLight-850 dark:text-grayDark-75 text-center w-full max-w-[85%] md:max-w-[320px]'>{localization.yourLostYourConnectionCaption}</Text>
      <Button
        className='mt-6 text-[18px] rounded-full px-4'
        style={{height: '52px'}}
        size={SIZE_ENUM.XL}
        onClick={() => location.reload()}
      >
        <FontIcon icon="icon-arrow-circlepath" className="text-xl"/>
        <span className="pr-2">{localization.tryAgain}</span>
      </Button>
    </Container>
  );
};
export default OffLine;
